exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* .full-screen-image img{\n  max-width: 480px;\n  max-height: 480px;\n  margin-top: 23px;\n} */\n.full-screen-image {\n  /* height: 450px; */\n  height: calc(100vh - 269.76px);\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  position: relative;\n  z-index:2;\n}\n.full-screen-image__container {\n  /* width: 500px; */\n  width: 90%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.full-screen-image__img{\n  max-width: 50vw;\n  max-height: 50vh;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/components/ImageLibrary/FullScreenImage.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/components/ImageLibrary/FullScreenImage.css
// module chunks = 120